import { Component, Input } from '@angular/core';
import { ResourcesService } from '@wz-services';
import { PolicyModels } from 'models/policy.models';
import moment from 'moment';

@Component({
  selector: 'wz-bank-reject-reason-indicator',
  templateUrl: './bank-reject-reason-indicator.component.html',
  styleUrls: ['./bank-reject-reason-indicator.component.scss'],
  standalone: false,
})
export class BanjRejectReasonIndicatorComponent {
  public tooltipText!: string;
  private _resourcesService: ResourcesService;

  constructor(private resourcesService: ResourcesService) {
    this._resourcesService = this.resourcesService;
  }

  @Input()
  public set bankRejectDetails(value: PolicyModels.RejectDetails) {
    moment.locale('fr');
    this.tooltipText =
      'Raison: ' +
      this._resourcesService.getResourceByEnumKey(
        value.reason,
        'BANK_REJECT_REASON_ENUM',
      ) +
      '\n' +
      'Date de rejet: ' +
      moment(value.date).format('L') +
      '\n' +
      'Titulaire compte: ' +
      value.debtorName +
      '\n' +
      'IBAN: ' +
      value.iban +
      '\n' +
      'BIC: ' +
      value.bic;
  }
}
